import React from 'react';
import { Children, cloneElement, memo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import {
    AppBar as MuiLamsAppBar,
    AppBarProps as MuiAppBarProps,
    IconButton,
    Toolbar,
    Tooltip,
    Typography,
    useMediaQuery,
    // Theme,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { toggleSidebar, useTranslate, ComponentPropType } from 'ra-core';
import MyTab from './mytab';

const useStyles = makeStyles(
    theme => ({
        toolbar: {
            paddingRight: 24,
        },
        menuButton: {
            marginLeft: '0.2em',
            marginRight: '0.2em',
        },
        menuButtonIconClosed: {
            transition: theme.transitions.create(['transform'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            transform: 'rotate(0deg)',
        },
        menuButtonIconOpen: {
            transition: theme.transitions.create(['transform'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            transform: 'rotate(180deg)',
        },
        title: {
            flex: 1,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
        },
    }),
    { name: 'RaLamsAppBar' }
);

/**
 * The LamsAppBar component renders a custom MuiLamsAppBar.
 *
 * @param {Object} props
 * @param {ReactNode} props.children React node/s to be render as children of the LamsAppBar
 * @param {Object} props.classes CSS class names
 * @param {string} props.className CSS class applied to the MuiLamsAppBar component
 * @param {string} props.color The color of the LamsAppBar
 * @param {Component} props.logout The logout button component that will be pass to the UserMenu component
 * @param {boolean} props.open State of the <Admin/> Sidebar
 * @param {Element | boolean} props.userMenu A custom user menu component for the LamsAppBar. <UserMenu/> component by default. Pass false to disable.
 *
 * @example
 *
 * const MyLamsAppBar = props => {
 *   const classes = useStyles();
 *   return (
 *       <LamsAppBar {...props}>
 *           <Typography
 *               variant="h6"
 *               color="inherit"
 *               className={classes.title}
 *               id="react-admin-title"
 *           />
 *       </LamsAppBar>
 *   );
 *};
 *
 * @example Without a user menu
 *
 * const MyLamsAppBar = props => {
 *   const classes = useStyles();
 *   return (
 *       <LamsAppBar {...props} userMenu={false} />
 *   );
 *};
 */
const LamsAppBar = (props: AppBarProps): JSX.Element => {
    const {
        children,
        classes: classesOverride,
        className,
        color = 'secondary',
        logout,
        open,
        title,
        userMenu,
        container: Container,
        ...rest
    } = props;
    const classes = useStyles(props);
   

    return (
        // <Container>
        // <Typography component="div" style={{ backgroundColor: '#cfe8fc', height: '100vh' }} />

        <MuiLamsAppBar className={className} color={color} {...rest}>
            <Toolbar
                disableGutters
                variant={'dense'}
                className={classes.toolbar}
            >
                <MyTab /><a target="_blank" href="https://www.lamsaz.com"><img style={{ width: 50 }} src="https://lamsaz.com/images/LAMSLogo.jpg" title="LAMS logo" /></a>
                <MyTab />
            
                {Children.count(children) === 0 ? (
                    <Typography
                        variant="h6"
                        color="inherit"
                        className={classes.title}
                        id="react-admin-title"
                    />
                ) : (
                    children
                )}
            
            </Toolbar>
        </MuiLamsAppBar >
    );
};

LamsAppBar.propTypes = {
    children: PropTypes.node,
    // @ts-ignore
    classes: PropTypes.object,
    className: PropTypes.string,
    color: PropTypes.oneOf([
        'default',
        'inherit',
        'primary',
        'secondary',
        'transparent',
    ]),
    container: ComponentPropType,
    logout: PropTypes.element,
    open: PropTypes.bool,
    userMenu: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
};


export default LamsAppBar;